// Core viewer
import { Viewer, Worker } from '@react-pdf-viewer/core';

// Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { config } from 'variables/config';
import { Typography } from '@mui/material';


const PDFViewer = ({ fileName, customUrl }) => {

    // Create new plugin instance
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div style={{ maxHeight: '100vh' , overflow: 'auto' }} >
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                {(fileName || customUrl) ? <Viewer
                    fileUrl={customUrl || `${config.app.api_url}/files/${fileName}`}
                    plugins={[
                        // Register plugins
                        defaultLayoutPluginInstance,
                    ]}

                /> :
                    <Typography variant="body1" color={'red'} fontStyle={'italic'} >Aucun url fourni</Typography>
                }
            </Worker>
        </div>

    )
}

export default PDFViewer;